import { a as getForModel, c as getAllMarkupsIsProposedAsTypical, d as exportMarkups, f as deleteMarkup, i as getScreenshot, l as getAllMarkupByModelIds, n as updateMarkup, o as getCountForModel, p as addMarkup, r as getScreenshotsByModelId, s as getById, t as uploadScreenshot, u as getAll3 } from "./uploadScreenshot.js";
import { mutationOptions, queryOptions, useMutation, useQuery } from "@tanstack/react-query";
//#region src/__generated__/viewer/markupController/hooks/useAddMarkup.ts
const addMarkupMutationKey = () => [{ url: "/api/viewer/markup/:projectId" }];
function addMarkupMutationOptions(config = {}) {
	const mutationKey = addMarkupMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body, headers }) => {
			const { data } = await addMarkup({
				...config,
				path,
				body,
				headers,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Добавить примечание.
* {@link /api/viewer/markup/:projectId}
*/
function useAddMarkup(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? addMarkupMutationKey();
	const baseOptions = addMarkupMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/viewer/markupController/hooks/useDeleteMarkup.ts
const deleteMarkupMutationKey = () => [{ url: "/api/viewer/markup/markup/:markupId" }];
function deleteMarkupMutationOptions(config = {}) {
	const mutationKey = deleteMarkupMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path }) => {
			const { data } = await deleteMarkup({
				...config,
				path,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Удалить примечание.
* {@link /api/viewer/markup/markup/:markupId}
*/
function useDeleteMarkup(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? deleteMarkupMutationKey();
	const baseOptions = deleteMarkupMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/viewer/markupController/hooks/useExportMarkups.ts
const exportMarkupsMutationKey = () => [{ url: "/api/viewer/markup/export/bcf" }];
function exportMarkupsMutationOptions(config = {}) {
	const mutationKey = exportMarkupsMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await exportMarkups({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Собирает BCF-файл, который содержит переданные примечания
* {@link /api/viewer/markup/export/bcf}
*/
function useExportMarkups(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? exportMarkupsMutationKey();
	const baseOptions = exportMarkupsMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/viewer/markupController/hooks/useGetAll3.ts
const getAll3QueryKey = ({ path }) => [{
	url: "/api/viewer/markup/:projectId",
	params: path
}];
function getAll3QueryOptions({ path }, config = {}) {
	const queryKey = getAll3QueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getAll3({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть все примечания по id проекта.
* {@link /api/viewer/markup/:projectId}
*/
function useGetAll3({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getAll3QueryKey(resolvedParams);
	const queryResult = useQuery({
		...getAll3QueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/viewer/markupController/hooks/useGetAllMarkupByModelIds.ts
const getAllMarkupByModelIdsMutationKey = () => [{ url: "/api/viewer/markup/report" }];
function getAllMarkupByModelIdsMutationOptions(config = {}) {
	const mutationKey = getAllMarkupByModelIdsMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await getAllMarkupByModelIds({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть все замечания по переданным model id.
* {@link /api/viewer/markup/report}
*/
function useGetAllMarkupByModelIds(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? getAllMarkupByModelIdsMutationKey();
	const baseOptions = getAllMarkupByModelIdsMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/viewer/markupController/hooks/useGetAllMarkupsIsProposedAsTypical.ts
const getAllMarkupsIsProposedAsTypicalMutationKey = () => [{ url: "/api/viewer/markup/typical/report" }];
function getAllMarkupsIsProposedAsTypicalMutationOptions(config = {}) {
	const mutationKey = getAllMarkupsIsProposedAsTypicalMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async (_) => {
			const { data } = await getAllMarkupsIsProposedAsTypical({
				...config,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть все примечания, которые предложены как типовые.
* {@link /api/viewer/markup/typical/report}
*/
function useGetAllMarkupsIsProposedAsTypical(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? getAllMarkupsIsProposedAsTypicalMutationKey();
	const baseOptions = getAllMarkupsIsProposedAsTypicalMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/viewer/markupController/hooks/useGetById.ts
const getByIdQueryKey = ({ path }) => [{
	url: "/api/viewer/markup/markup/:markupId",
	params: path
}];
function getByIdQueryOptions({ path }, config = {}) {
	const queryKey = getByIdQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getById({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть примечание по id.
* {@link /api/viewer/markup/markup/:markupId}
*/
function useGetById({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getByIdQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getByIdQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/viewer/markupController/hooks/useGetCountForModel.ts
const getCountForModelQueryKey = ({ path }) => [{
	url: "/api/viewer/markup/model/:modelId/count",
	params: path
}];
function getCountForModelQueryOptions({ path }, config = {}) {
	const queryKey = getCountForModelQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getCountForModel({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть количество примечаний, привязанных к модели.
* {@link /api/viewer/markup/model/:modelId/count}
*/
function useGetCountForModel({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getCountForModelQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getCountForModelQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/viewer/markupController/hooks/useGetForModel.ts
const getForModelQueryKey = ({ path }) => [{
	url: "/api/viewer/markup/model/:modelId",
	params: path
}];
function getForModelQueryOptions({ path }, config = {}) {
	const queryKey = getForModelQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getForModel({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть все примечания по id модели.
* {@link /api/viewer/markup/model/:modelId}
*/
function useGetForModel({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getForModelQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getForModelQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/viewer/markupController/hooks/useGetScreenshot.ts
const getScreenshotQueryKey = ({ path }) => [{
	url: "/api/viewer/markup/markup/:markupId/screenshot",
	params: path
}];
function getScreenshotQueryOptions({ path }, config = {}) {
	const queryKey = getScreenshotQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getScreenshot({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть скрин примечания в формате Base64.
* {@link /api/viewer/markup/markup/:markupId/screenshot}
*/
function useGetScreenshot({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getScreenshotQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getScreenshotQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/viewer/markupController/hooks/useGetScreenshotsByModelId.ts
const getScreenshotsByModelIdQueryKey = ({ path }) => [{
	url: "/api/viewer/markup/model/:modelId/screenshots",
	params: path
}];
function getScreenshotsByModelIdQueryOptions({ path }, config = {}) {
	const queryKey = getScreenshotsByModelIdQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getScreenshotsByModelId({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть скрины примечания по id модели в формате Base64.
* {@link /api/viewer/markup/model/:modelId/screenshots}
*/
function useGetScreenshotsByModelId({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getScreenshotsByModelIdQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getScreenshotsByModelIdQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/viewer/markupController/hooks/useUpdateMarkup.ts
const updateMarkupMutationKey = () => [{ url: "/api/viewer/markup/markup/:markupId" }];
function updateMarkupMutationOptions(config = {}) {
	const mutationKey = updateMarkupMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await updateMarkup({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Обновить информацию примечания.
* {@link /api/viewer/markup/markup/:markupId}
*/
function useUpdateMarkup(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? updateMarkupMutationKey();
	const baseOptions = updateMarkupMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/viewer/markupController/hooks/useUploadScreenshot.ts
const uploadScreenshotMutationKey = () => [{ url: "/api/viewer/markup/markup/:markupId/screenshot" }];
function uploadScreenshotMutationOptions(config = {}) {
	const mutationKey = uploadScreenshotMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body, headers }) => {
			const { data } = await uploadScreenshot({
				...config,
				path,
				body,
				headers,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Загрузить скрин примечания.
* {@link /api/viewer/markup/markup/:markupId/screenshot}
*/
function useUploadScreenshot(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? uploadScreenshotMutationKey();
	const baseOptions = uploadScreenshotMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
export { useGetAll3 as A, getAllMarkupsIsProposedAsTypicalMutationOptions as C, useGetAllMarkupByModelIds as D, getAllMarkupByModelIdsMutationOptions as E, deleteMarkupMutationOptions as F, useDeleteMarkup as I, addMarkupMutationKey as L, exportMarkupsMutationOptions as M, useExportMarkups as N, getAll3QueryKey as O, deleteMarkupMutationKey as P, addMarkupMutationOptions as R, getAllMarkupsIsProposedAsTypicalMutationKey as S, getAllMarkupByModelIdsMutationKey as T, getCountForModelQueryOptions as _, updateMarkupMutationOptions as a, getByIdQueryOptions as b, getScreenshotsByModelIdQueryOptions as c, getScreenshotQueryOptions as d, useGetScreenshot as f, getCountForModelQueryKey as g, useGetForModel as h, updateMarkupMutationKey as i, exportMarkupsMutationKey as j, getAll3QueryOptions as k, useGetScreenshotsByModelId as l, getForModelQueryOptions as m, uploadScreenshotMutationOptions as n, useUpdateMarkup as o, getForModelQueryKey as p, useUploadScreenshot as r, getScreenshotsByModelIdQueryKey as s, uploadScreenshotMutationKey as t, getScreenshotQueryKey as u, useGetCountForModel as v, useGetAllMarkupsIsProposedAsTypical as w, useGetById as x, getByIdQueryKey as y, useAddMarkup as z };

//# sourceMappingURL=useUploadScreenshot.js.map